import { ExtractEventType } from './../extract.event.type';
import { AppEventDispatcher } from './../../../utils/AppEventDispatcher';
import { TweenMax, Quint } from 'gsap';
import { Component, OnInit, ViewEncapsulation, Input, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material';
import * as moment from 'moment';
import { EventTypes } from '../../../shared/EventTypes';

@Component({
	selector: 'app-special-filter',
	templateUrl: './special-filter.component.html',
	styleUrls: ['./special-filter.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class SpecialFilterComponent implements OnInit, OnDestroy {

	@Input() daysAgo: number;

	formPeriod: FormGroup;
	periodOpened = false;
	periodMark = false;

	dateBeginError = false;
	dateEndError = false;

	constructor(private route: ActivatedRoute, private router: Router, private formBuilder: FormBuilder) {
		this.formPeriod = formBuilder.group({
			'dateBegin': [null, Validators.required],
			'dateEnd': [null, Validators.required]
		});

	}

	ngOnInit() {
		AppEventDispatcher.listen(ExtractEventType.PERIOD_URL, (data) => {
			if (data) {
				this.periodMark = true;
				this.daysAgo = 100;
			}	else {
				this.periodMark = false;
				this.daysAgo = Number(this.route.routeConfig.data.days);
			}
		});
	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(ExtractEventType.PERIOD_URL);
	}

	togglePeriodLayer(periodOpened) {
		this.periodOpened = periodOpened;

		if (!this.periodOpened) {
			this.periodOpened = true;
			if (!this.periodMark) {
				this.daysAgo = 100;
			}
			TweenMax.to('[data-component="special-filter"] .period-layer', .8, {autoAlpha: 1, top: 80, ease: Quint.easeOut});
		}	else {
			this.periodOpened = false;
			if (!this.periodMark) {
				this.daysAgo = Number(this.route.routeConfig.data.days);
			}
			TweenMax.to('[data-component="special-filter"] .period-layer', .6, {autoAlpha: 0, top: 60, ease: Quint.easeOut});
		}
	}

	onSubmit() {

		if (!this.formPeriod.controls.dateBegin.valid) {
			this.dateBeginError = true;
		} else {
			this.dateBeginError = false;
		}

		if (!this.formPeriod.controls.dateEnd.valid) {
			this.dateEndError = true;
		} else {
			this.dateEndError = false;
		}

		if (this.formPeriod.valid) {

			if (moment(this.formPeriod.controls.dateBegin.value).isSameOrBefore(this.formPeriod.controls.dateEnd.value)) {
				this.dateBeginError = false;
				this.dateEndError = false;

				this.router.navigate(['extrato/periodo']);

				AppEventDispatcher.dispatch(ExtractEventType.PERIOD_URL, {data: true});
				this.togglePeriodLayer(true);

				TweenMax.delayedCall(.4, () => {
					AppEventDispatcher.dispatch(ExtractEventType.UPDATE.BY_PERIOD, this.formPeriod.value);
				});
			} else {
				this.dateEndError = true;
				this.dateBeginError = true;

				AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, {msg: 'A data inicial, deve ser menor que a data final.'});
			}

		}

	}

	changeDate() {

		if (!this.formPeriod.controls.dateBegin.valid) {
			this.dateBeginError = true;
		} else {
			this.dateBeginError = false;
		}

		if (!this.formPeriod.controls.dateEnd.valid) {
			this.dateEndError = true;
		} else {
			this.dateEndError = false;
		}

	}

	goTo(route) {
		this.router.navigate([route]);
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/extract/special-filter/special-filter.component.ts